export enum NotificationMessageCode {
  REPORT_GENERATION_STARTED = 'ReportGenerationStarted',
  REPORT_GENERATION_FINISHED_SUCCESSFULLY = 'ReportGenerationFinishedSuccessfully',
  REPORT_GENERATION_FAILED = 'ReportGenerationFailed',
  SHARE_LINK_FIRST_ACCESSED = 'ShareLinkFirstAccessed'
}
